import React, {useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {actionsState as projectState} from "../Redux/project";
import {actionsState as modulesState} from "../Redux/modules";
import VariantDropBoxSimple from "./widgets/VariantDropBoxSimple";
import {formatPrice, getStrLang} from "../Helpers/functions";
import {sendRedrawSimpleEvent, sendUnselectEvent} from "../Helpers/Events";
const Modules = ()=>{
    const dispatch = useDispatch();
    const arAllPrices = useSelector(store=>store.modules.arAllPrices);
    const allModules = useSelector(store=>store.modules.allModules);
    const canvasCenter = useSelector(store=>store.project.plan.canvasCenter);
    const sections = useSelector(store=>store.modules.sections);
    const [activeSection,setActiveSection] = useState(sections.length>0?sections[0]:null);
    const modules = activeSection?allModules.filter(m=>m.SECTION===activeSection.ID && m.SHOW):allModules.filter(m=>m.SECTION>0 && m.SHOW);
    const addModule = (module)=>{
        module.canvasCenter = canvasCenter
        dispatch(modulesState.addModule(module));
        dispatch(projectState.setModal(''));
        sendUnselectEvent(document.querySelector('#plan'));
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }
    // console.log('arAllPrices',arAllPrices)
    // console.log('sections',sections)
    return <div className="app__fullmodal">
        <div className="fullmodal-menu hom">
            <h2 className="fullmodal-menu_title">{ getStrLang('c3d_ooZfG') }</h2>
            <ul>
                {sections.map(s=><li
                    className={activeSection===s?'active':''}
                    key={s.ID}
                    onClick={()=>setActiveSection(s)}
                >{s.NAME}</li>)}
            </ul>
        </div>

        <div className="fullmodal-block">
            <div className="fullmodal-header">
                <h2 className="fullmodal-header_title hom">{activeSection.NAME}</h2>
                <h2 className="fullmodal-header_title som">{ getStrLang('c3d_ondsO') }</h2>
                <div className="fullmodal-header_btn" onClick={()=>{dispatch(projectState.setModal(''))}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                        <g stroke="currentColor">
                            <line x1="1" y1="1" x2="18" y2="18"></line>
                            <line x1="18" y1="1" x2="1" y2="18"></line>
                        </g>
                    </svg>
                </div>
            </div>
            <VariantDropBoxSimple
                list = {sections}
                active = {activeSection}
                title = {false}
                setActive = {setActiveSection}
                classes = {'som'}
            />
            <div className={"options-title som"}>{ getStrLang('c3d_sac3H') }</div>
            <div className="fullmodal-body">

                {modules.map(m=>{
                    return <div key={m.ID} className="module-card">
                        <div className="card-img"><img src={m.IMAGE} alt=""/></div>
                        <div className="card-right">
                            <div className="card-section">
                                <div className="card-name">{m.NAME}</div>
                            </div>
                            <div className="card-btns">
                                <div className="card-price">{(arAllPrices[m.ID][1] > 0)?formatPrice(arAllPrices[m.ID][1]):''}&nbsp;</div>
                                <span className="btn btn-add" onClick={()=>addModule(m)}>{ getStrLang('c3d_B5aBt') }</span>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>
    </div>
}
export default Modules;
